module.exports = __webpack_public_path__ + "img/stmicroelectronics-m5.1831c005.jpg";